import React from 'react'
import { NavLink, useLocation } from 'react-router-dom' // Import NavLink instead of Link
import { HashLink } from 'react-router-hash-link'; 
import Home from '../Views/Home'
import About from '../Views/About'

const Header = () => {
    const location = useLocation();
    console.log(location);
    return (
        <>
            <header className={`header_wrappper version1 ${location.pathname === '/privacy' || location.pathname === '/terms'? 'bg_stable' : ''  }`} id="header">
                <div className="wrap">
                    <div className="container null">
                        <NavLink to="/" element={<Home />} className={({ isActive }) => (isActive ? "main_logo icon active" : "main_logo icon")}>
                            <img src="images/main_logo.svg" alt="" className="" />
                        </NavLink>
                        <nav>
                            <div id="hamburger" className="hamburger">
                                <div className="menu-btn-1">
                                    <span></span>
                                </div>
                            </div>
                            <div className="custom_collapse closed">
                                <ul>
                                    <li className={({ isActive }) => "active"}><NavLink to="/" element={<Home />} className={({ isActive }) => (isActive ? "active" : "")}>Home</NavLink></li>
                                    <li><HashLink to="/#features" className={({ isActive }) => (isActive ? "features_link custom_link active" : "features_link custom_link")}>Features</HashLink></li>
                                    <li><NavLink to="about" element={<About />} className={({ isActive }) => (isActive ? "active" : "")}>About Us</NavLink></li>
                                    <li>
                                        <a href="https://support.peckdating.com/hc/en-us">FAQ</a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header
